"use client";

import { useState, useEffect, useRef, useCallback } from "react";

const DOC_NAMES = ["RAMS", "CPP", "Toolbox Talk", "Site Induction", "Emergency Plan"];

export function CyclingDocType() {
  const [index, setIndex] = useState(0);
  const [fade, setFade] = useState(true);
  const [width, setWidth] = useState<number | undefined>(undefined);
  const refs = useRef<(HTMLSpanElement | null)[]>([]);

  const measureWidth = useCallback((i: number) => {
    const el = refs.current[i];
    if (el) setWidth(el.offsetWidth);
  }, []);

  // Measure initial width after mount
  useEffect(() => {
    measureWidth(0);
  }, [measureWidth]);

  useEffect(() => {
    const interval = setInterval(() => {
      // 1. Fade out old text
      setFade(false);
      setTimeout(() => {
        // 2. Swap text + start width transition (text still invisible)
        setIndex((prev) => {
          const next = (prev + 1) % DOC_NAMES.length;
          measureWidth(next);
          return next;
        });
        // 3. Wait for width transition to finish, then fade in
        setTimeout(() => {
          setFade(true);
        }, 300);
      }, 300);
    }, 2500);
    return () => clearInterval(interval);
  }, [measureWidth]);

  return (
    <span
      className="relative inline-block text-brand-700 align-bottom transition-[width] duration-300"
      style={{ width: width ? `${width}px` : "auto" }}
    >
      {/* Off-screen measurer spans */}
      {DOC_NAMES.map((name, i) => (
        <span
          key={name}
          ref={(el) => { refs.current[i] = el; }}
          className="invisible absolute left-0 top-0 whitespace-nowrap"
          aria-hidden
        >
          {name}
        </span>
      ))}
      {/* Visible cycling word */}
      <span
        className={`whitespace-nowrap transition-opacity duration-300 ${
          fade ? "opacity-100" : "opacity-0"
        }`}
      >
        {DOC_NAMES[index]}
      </span>
    </span>
  );
}
